import { useEffect } from 'react';
import type { ChoiceCardChromeType } from '../utils/siteBriefChoiceChrome';
import { fontStack, loadSiteBriefFont } from '../utils/siteBriefFonts';

type SiteBriefFontSpecimenProps = {
  chrome: ChoiceCardChromeType;
  heading: string;
  body: string;
};

// A short specimen of a heading and a body family, set in the real fonts.
export default function SiteBriefFontSpecimen({ chrome, heading, body }: SiteBriefFontSpecimenProps) {
  useEffect(() => {
    loadSiteBriefFont(heading);
    loadSiteBriefFont(body);
  }, [heading, body]);

  return (
    <span className="sb-font-specimen" aria-hidden="true">
      <span className="sb-font-specimen__aa" style={{ fontFamily: fontStack(heading) }}>
        Aa
      </span>
      <span className="sb-font-specimen__copy">
        <span className="sb-font-specimen__heading" style={{ fontFamily: fontStack(heading) }}>
          {chrome.specimenHeading}
        </span>
        <span className="sb-font-specimen__body" style={{ fontFamily: fontStack(body) }}>
          {chrome.specimenBody}
        </span>
      </span>
    </span>
  );
}
